module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trial-lockout-overlay",
    style: (_vm.overlayStyle)
  }, [_c('div', {
    staticClass: "trial-lockout-modal",
    attrs: {
      "role": "dialog",
      "aria-labelledby": "trial-lockout-title"
    }
  }, [_c('div', {
    staticClass: "trial-lockout-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "viewBox": "0 0 24 24"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "11",
      "width": "18",
      "height": "11",
      "rx": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 11V7a5 5 0 0110 0v4"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "trial-lockout-title",
    attrs: {
      "id": "trial-lockout-title"
    }
  }, [_vm._v("Your trial has ended")]), _vm._v(" "), _c('p', {
    staticClass: "trial-lockout-sub"
  }, [_vm._v("\n      Pick a plan to resume access to your dashboard, alerts, and tracking. Your data is safe —\n      service resumes the moment you complete checkout.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "trial-lockout-plans"
  }, [_c('button', {
    class: ['trial-lockout-plan', {
      selected: _vm.selectedPlanKey === 'starter'
    }],
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.startStarterUpgradeFlow
    }
  }, [(_vm.selectedPlanKey === 'starter') ? _c('span', {
    staticClass: "trial-lockout-plan-badge"
  }, [_vm._v("Your selection")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "trial-lockout-plan-name"
  }, [_vm._v("Starter")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('button', {
    class: ['trial-lockout-plan', 'recommended', {
      selected: _vm.selectedPlanKey === 'pro'
    }],
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.startProUpgradeFlow
    }
  }, [(_vm.selectedPlanKey === 'pro') ? _c('span', {
    staticClass: "trial-lockout-plan-badge"
  }, [_vm._v("Your selection")]) : _c('span', {
    staticClass: "trial-lockout-plan-badge"
  }, [_vm._v("★ Recommended")]), _vm._v(" "), _c('div', {
    staticClass: "trial-lockout-plan-name"
  }, [_vm._v("Pro")]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('button', {
    staticClass: "trial-lockout-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.startProUpgradeFlow
    }
  }, [_vm._v("\n      " + _vm._s(_vm.busy ? 'Please wait…' : 'Continue with Pro →') + "\n    ")]), _vm._v(" "), (_vm.errorMessage) ? _c('p', {
    staticClass: "trial-lockout-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "trial-lockout-foot"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.openComparePlans
    }
  }, [_vm._v("Compare plans")]), _vm._v("\n      ·\n      "), _c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Log out")])])]), _vm._v(" "), (_vm.comparePlansOpen) ? _c('div', {
    staticClass: "trial-compare-backdrop",
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeComparePlans.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "trial-compare-modal",
    attrs: {
      "role": "dialog",
      "aria-labelledby": "trial-compare-title",
      "aria-modal": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    staticClass: "trial-compare-close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeComparePlans
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "trial-compare-title",
    attrs: {
      "id": "trial-compare-title"
    }
  }, [_vm._v("Compare plans")]), _vm._v(" "), _c('p', {
    staticClass: "trial-compare-sub"
  }, [_vm._v("Pick the plan that fits your order volume. You can change plans anytime from billing.")]), _vm._v(" "), _c('div', {
    staticClass: "trial-compare-grid"
  }, [_c('div', {
    class: ['trial-compare-col', {
      selected: _vm.selectedPlanKey === 'starter'
    }]
  }, [(_vm.selectedPlanKey === 'starter') ? _c('span', {
    staticClass: "trial-compare-badge"
  }, [_vm._v("Your selection")]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "trial-compare-plan-name"
  }, [_vm._v("Starter")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('button', {
    staticClass: "trial-compare-btn trial-compare-btn-outline",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.onCompareSelectStarter
    }
  }, [_vm._v("\n            Choose Starter\n          ")])]), _vm._v(" "), _c('div', {
    class: ['trial-compare-col', 'trial-compare-col-pro', {
      selected: _vm.selectedPlanKey === 'pro'
    }]
  }, [(_vm.selectedPlanKey === 'pro') ? _c('span', {
    staticClass: "trial-compare-badge"
  }, [_vm._v("Your selection")]) : _c('span', {
    staticClass: "trial-compare-badge"
  }, [_vm._v("★ Recommended")]), _vm._v(" "), _c('h3', {
    staticClass: "trial-compare-plan-name"
  }, [_vm._v("Pro")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "trial-compare-plus"
  }, [_vm._v("Everything in Starter, plus:")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('button', {
    staticClass: "trial-compare-btn trial-compare-btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.onCompareSelectPro
    }
  }, [_vm._v("\n            " + _vm._s(_vm.busy ? 'Please wait…' : 'Continue with Pro →') + "\n          ")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trial-lockout-plan-price"
  }, [_vm._v("$19"), _c('span', {
    staticClass: "per"
  }, [_vm._v("/mo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trial-lockout-plan-price"
  }, [_vm._v("$49"), _c('span', {
    staticClass: "per"
  }, [_vm._v("/mo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "trial-compare-price"
  }, [_vm._v("$19"), _c('span', {
    staticClass: "per"
  }, [_vm._v("/mo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "trial-compare-features"
  }, [_c('li', [_vm._v("All alert types · real-time delivery")]), _vm._v(" "), _c('li', [_vm._v("Directional signals from Day 1")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Pattern insights from Day 15")])]), _vm._v(" "), _c('li', [_vm._v("Action signals from Day 30+")]), _vm._v(" "), _c('li', [_vm._v("COGS, floor price & margin alerts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "trial-compare-price"
  }, [_vm._v("$49"), _c('span', {
    staticClass: "per"
  }, [_vm._v("/mo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "trial-compare-features"
  }, [_c('li', [_c('strong', [_vm._v("Competitor seller profiles")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Seller name, location & storefront")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4526b9c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buybox/TrialLockoutOverlay.vue
// module id = 765
// module chunks = 2